var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { queryAssignedElements } from 'lit/decorators.js';
import { SdsSelect } from '../../dropdown/select/sds-select.lit';
import { SdsInputPrefixSuffixBase } from '../_sds-input-prefix-suffix-base';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * Control that represents Input Suffix.
 *
 * @slot - This slot is the container for the input component
 * @slot suffix - This slot is the container for the suffix component
 */
let SdsInputSuffix = (() => {
    var _SdsInputSuffix__suffixes_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-input-suffix')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsInputPrefixSuffixBase;
    let __suffixes_decorators;
    let __suffixes_initializers = [];
    let __suffixes_extraInitializers = [];
    var SdsInputSuffix = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsInputSuffix__suffixes_accessor_storage.set(this, __runInitializers(this, __suffixes_initializers, void 0));
            this.suffixSlotChangeHandler = (__runInitializers(this, __suffixes_extraInitializers), () => {
                var _a, _b;
                if (this._suffixes[0] instanceof SdsSelect) {
                    (_b = (_a = this._suffixes[0].shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-input-select')) === null || _b === void 0 ? void 0 : _b.setAttribute('suffix', '');
                    this._suffixes[0].addEventListener(SdsSelect.SELECTED_EVENT, this.suffixSelectedHandler);
                }
            });
            this.suffixSelectedHandler = (event) => {
                this.dispatchSuffixSelected(event.detail.identifier);
            };
        }
        get _suffixes() { return __classPrivateFieldGet(this, _SdsInputSuffix__suffixes_accessor_storage, "f"); }
        set _suffixes(value) { __classPrivateFieldSet(this, _SdsInputSuffix__suffixes_accessor_storage, value, "f"); }
        render() {
            this.addGlobalStyle();
            return html `
            <div id="container" class="${this.getClasses()}">
                <slot @slotchange="${this.inputSlotChangeHandler}"></slot>
                <slot name="suffix" @slotchange="${this.suffixSlotChangeHandler}"></slot>
                ${this.renderLabel()}
            </div>
            ${this.renderError()}
        `;
        }
        renderError() {
            if (this.errorMessage && this.invalid) {
                return html `
                <sds-error style="margin-top: 4px;" message="${this.errorMessage}"></sds-error>
            `;
            }
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        dispatchSuffixSelected(identifier) {
            this.dispatchEvent(new CustomEvent(SdsInputSuffix.SUFFIX_SELECTED, {
                detail: {
                    identifier: identifier,
                },
            }));
        }
    };
    _SdsInputSuffix__suffixes_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsInputSuffix");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __suffixes_decorators = [queryAssignedElements({ slot: 'suffix' })];
        __esDecorate(_classThis, null, __suffixes_decorators, { kind: "accessor", name: "_suffixes", static: false, private: false, access: { has: obj => "_suffixes" in obj, get: obj => obj._suffixes, set: (obj, value) => { obj._suffixes = value; } }, metadata: _metadata }, __suffixes_initializers, __suffixes_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsInputSuffix = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.SUFFIX_SELECTED = 'sds.suffix.selected';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsInputSuffix = _classThis;
})();
export { SdsInputSuffix };
